import { BreadcrumbItem } from '@mi-front/ui';
import compact from 'lodash/compact';
import { Page } from '../../page/Page';
import { StationNavigatorBreadcrumb } from './StationNavigatorBreadcrumb';

interface Props {
  readonly root?: BreadcrumbItem;
  readonly size?: 'small' | 'medium';
  readonly items?: readonly BreadcrumbItem[];
  readonly basePath: string;
  readonly activeId: string;
}

export function StationsBreadcrumbs({ root, items, size = 'medium', basePath, activeId }: Props) {
  return (
    <Page.Breadcrumbs
      items={compact([
        root,
        {
          content: (
            <StationNavigatorBreadcrumb basePath={basePath} activeId={activeId} size={size} />
          ),
        },
        ...(items ?? []),
      ])}
    />
  );
}
